import { create } from "zustand";

const LS_ACTIVE_EVENT_MINIMIZED = "rideconnect_active_event_minimized";

type UiState = {
  recordingLock: boolean;
  setRecordingLock: (v: boolean) => void;

  activeEventMinimized: boolean;
  setActiveEventMinimized: (v: boolean) => void;
};

const useUiStore = create<UiState>((set) => ({
  recordingLock: false,
  setRecordingLock: (v) => set({ recordingLock: v }),

  activeEventMinimized: localStorage.getItem(LS_ACTIVE_EVENT_MINIMIZED) === "1",
  setActiveEventMinimized: (v) => {
    localStorage.setItem(LS_ACTIVE_EVENT_MINIMIZED, v ? "1" : "0");
    set({ activeEventMinimized: v });
  },
}));

export default useUiStore;
